import Title from '../../components/title/Title';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { Link } from 'react-router-dom';
import { formatDateMin, formatNumber } from '../../misc/index';

const FacturasView = ({ request = {loading: false, error: false, errorMsg: ''}, documentos = [], onExportClick = () => {} }) => {


    return(
        <div className='page-container'>
            <Title>Saldo</Title>
    
            {request.loading ?
                <div className='loading-spinner'>
                    <Spinner animation="border" variant="primary" />
                </div>
            :
                <div className='page-body'>
                    <table className='info-table'>
                        <thead>
                            <tr>
                                <th>NO.</th>
                                <th>CENTRO DE OPERACION</th>
                                <th>FECHA</th>
                                <th>DOCUMENTO</th>
                                <th>DETALLE</th>
                                <th>DEBITOS</th>
                                <th>CREDITOS</th>
                                <th>VER</th>
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                documentos.map(
                                    (documento, index) => {
                                        return(
                                            <tr key={index}>
                                                <td>{ index + 1 }</td>
                                                <td>{ documento.idCo }</td>
                                                <td>{ formatDateMin(new Date(documento.date)) }</td>
                                                <td>{ documento.documentType + '-' + documento.documentNumber }</td>
                                                <td>{ documento.notes }</td>
                                                <td>${ formatNumber(documento.debitAmount) }</td>
                                                <td>${ formatNumber(documento.creditAmount) }</td>
                                                <td><div className='view-icon-container'>
                                                    { documento.isEgress == 1 ? 
                                                        documento.documentType == "NTC" ?
                                                            <Link to={{ pathname: "/portal/documento-financiero-detalle", state: { egreso: { saldoAbiertoRowid: documento.rowid } } }}><FontAwesomeIcon className='view-icon' icon={faEye} /></Link> 
                                                        :
                                                            <Link to={{ pathname: "/portal/egreso-detalle", state: { egreso: documento } }}><FontAwesomeIcon className='view-icon' icon={faEye} /></Link> 
                                                    :
                                                        <Link to={{ pathname: "/portal/documento-detalle", state: { documento: documento } }}><FontAwesomeIcon className='view-icon' icon={faEye} /></Link>
                                                    }
                                                </div></td>
                                            </tr>
                                        );
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default FacturasView;